export const invalidFileNameRegex = /^(?:_vti_|_|\.)+|[~#%&*{}\\:<>?/+|"]+|(?:\.\.)+|(?:\.|\.files|_files|-Dateien|_fichiers|_bestanden|_file|_archivos|-filer|_tiedostot|_pliki|_soubory|_elemei|_ficheiros|_arquivos|_dosyalar|_datoteke|_fitxers|_failid|_fails|_bylos|_fajlovi|_fitxategiak)$/g

export const fileSize = (a, b, c, d, e) => {
  return (b = Math, c = b.log, d = 1e3, e = c(a) / c(d) | 0, a / b.pow(d, e)).toFixed(1) +
  ' ' + (e ? 'kMGTPEZY'[--e] + 'B' : 'B')
}

export const getExtension = (name) => {
  let extension

  if (name && name.length > 0) {
    const index = name.lastIndexOf('.')
    if (index !== -1) {
      extension = name.substr(1 + index)
    }
  }

  return extension
}

export const getFileName = (name) => {
  let fileName

  if (name && name.length > 0) {
    const index = name.lastIndexOf('.')
    if (index !== -1) {
      fileName = name.substr(0, index)
    }
  }

  if (!fileName) return name

  return fileName
}

export const getIsMail = (name) => {
  const extension = getExtension(name)

  return (
    extension &&
    extension.toUpperCase() === 'EML'
  )
}

export const getIconName = (name, isFolder) => {
  if (isFolder) return 'folder-o'

  let extension = getExtension(name)

  if (extension !== undefined) {
    extension = extension.toUpperCase()
  }

  switch (extension) {
    case 'PDF':
      return 'file-pdf-o'
    case 'XLS':
    case 'XLSX':
    case 'XLA':
    case 'XLSM':
    case 'XLTX':
    case 'XLTM':
    case 'XLSB':
      return 'file-excel-o'
    case 'JPE':
    case 'JPG':
    case 'JPEG':
    case 'GIF':
    case 'PNG':
    case 'BMP':
    case 'ICO':
    case 'SVG':
    case 'SVGZ':
    case 'TIF':
    case 'TIFF':
    case 'AI':
    case 'DRW':
    case 'PCT':
    case 'PSP':
    case 'XCF':
    case 'PSD':
    case 'RAW':
      return 'file-image-o'
    case 'PPT':
    case 'PPS':
    case 'PPTX':
    case 'PPTM':
    case 'POTX':
    case 'POTM':
    case 'PPSX':
      return 'file-powerpoint-o'
    case 'AAC':
    case 'AIF':
    case 'FLAC':
    case 'IFF':
    case 'M4A':
    case 'M4B':
    case 'MID':
    case 'MIDI':
    case 'MP3':
    case 'MPA':
    case 'MPC':
    case 'OGA':
    case 'OGG':
    case 'RA':
    case 'RAM':
    case 'SND':
    case 'WAV':
    case 'WMA':
      return 'file-audio-o'
    case 'AVI':
    case 'DIVX':
    case 'FLV':
    case 'M4V':
    case 'MKV':
    case 'MOV':
    case 'MP4':
    case 'MPEG':
    case 'MPG':
    case 'OGM':
    case 'OGV':
    case 'OGX':
    case 'RM':
    case 'RMVB':
    case 'SMIL':
    case 'WEBM':
    case 'WMV':
    case 'XVID':
      return 'file-video-o'
    case 'DOC':
    case 'DOMX':
    case 'DOCX':
    case 'DOCM':
    case 'DOTM':
    case 'DOTX':
      return 'file-word-o'
    case 'HTM':
    case 'HTML':
    case 'XHT':
    case 'XHTML':
      return 'file-code-o'
    case 'EML':
    case 'PST':
      return 'envelope-o'
    case 'ZIP':
    case 'RAR':
    case '7Z':
      return 'file-archive-o'
    default:
      return 'file-o'
  }
}
